module.exports = __webpack_public_path__ + "static/media/remote.7c7bd643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/remote.svg
// module id = 72
// module chunks = 0